import React from 'react';
import { FormattedMessage } from 'react-intl';

const WeightLabel = () => <FormattedMessage defaultMessage='Weight' description='fulfillmentPlanner.weight' id='jYZAnX' />;

export default WeightLabel;
